import { render, staticRenderFns } from "./PersonalOverviewPanel.vue?vue&type=template&id=ab4c6274"
import script from "./PersonalOverviewPanel.vue?vue&type=script&lang=js"
export * from "./PersonalOverviewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports